import IdxReqs from '../shared/idx/idx-reqs';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Source from './sidebar/source';

class Disclaimers extends Component {
  render() {
    var homeOffice = this.props.listing.hasHomeOffice && this.props.region === 'nyc' ? (
      <div className="container">
        <div className="features-disclaimer">
          * Represents current apartment configuration, which may not conform to official
          legal documentation. Purchasers should consult with their legal or architectural
          professionals to determine legal use parameters.
        </div>
      </div>
    ) : null;
    return (
      <div className="sh-detail-idx-disclaimer">
        <div className="spacer-1"></div>
        {homeOffice}
        <div className="container">
          <div className="row features-disclaimer">
            <Source listing={this.props.listing} show={this.props.showBottomCourtesyInfo}/>
          </div>
          <IdxReqs config={this.props.config} listing={this.props.listing}/>
        </div>
      </div>
    );
  }
}

Disclaimers.propTypes = {
  config: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  showBottomCourtesyInfo: PropTypes.bool.isRequired
};

export default Disclaimers;


// WEBPACK FOOTER //
// ./src/components/listing-detail/disclaimers.js